

<app-nav-grouping-quiz-list
*ngIf="subscriptionGrouping"
[subscriptionGrouping]="subscriptionGrouping">
</app-nav-grouping-quiz-list>


<div class="row" *ngIf="subscriptionGrouping">
  <div class="col-sm-12">
    <h3 class="sub-title alert alert-info text-center">Quiz  for {{subscriptionGrouping['name']}}</h3>
  </div>

</div>

<div class="table-responsive" *ngIf="quizList">
<table   datatable [dtOptions]="dtOptions" class="table table-striped display compact" >
  <thead>
  <tr>
    <th>id</th>
    <th>Questions</th>
    <th>Students</th>
    <th>View</th>
  </tr>
  </thead>

  <tbody>
  <tr *ngFor="let quizItem of quizList;">
    <td><a [routerLink]="['/batch/grouping/quiz/show',server_subscription_grouping_id,quizItem.server_quiz_id]">{{quizItem['server_quiz_id']}}</a></td>
    <td>{{quizItem['question_count']}}</td>
    <td>{{quizItem['question_count']}}</td>
    <td>view</td>
  </tr>
  </tbody>

</table>
</div>

<div *ngIf="subscriptionGrouping">
<app-spinner *ngIf="loading"></app-spinner>
<div *ngIf="quizList && !loading" class="text-center">No Records Found </div>

<fieldset class="text-center" *ngIf="subscriptionGrouping">
  <a [routerLink]="['/batch/grouping/show',subscriptionGrouping['server_subscription_grouping_id']]" class="btn btn-primary">
    <i class ="fa fa-list"></i> Close
  </a>
</fieldset>
</div>


